<template>
  <div class="wraper-footer">
    <div class="footer-box">
      <div class="footer-left">
        <div class="logo-box"><img src="@/assets/logo.png" alt="logo" /></div>
        <div class="logo-slogan">独自开信息科技（上海）有限公司</div>
        <div class="center-link" @click="handleToGov">沪ICP备2022002561号</div>
      </div>
      <div class="footer-right">
<!--        <div class="item mail-box">
          <div class="label">联系电话</div>
          <div class="text">18101790606</div>
        </div>-->
        <div class="item mail-box">
          <div class="label">公司邮箱</div>
          <div class="text">public@duzikai.cn</div>
        </div>
        <div class="item address-box">
          <div class="label">公司地址</div>
          <div class="text">上海市浦东新区张江高科技园区郭守敬路498号19号楼</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Footer",
  methods: {
    handleJumpCenter() {
      console.log('123213123123131')
      window.open('http://www.duzikai.com/001_center_data_duzikai_official_website/dist/index.html#/login', '_blank')
    },

    handleToGov() {
      window.open('http://beian.miit.gov.cn')
    }
  }
};
</script>
<style scoped lang="less">
.wraper-footer {
  width: 100%;
  background-color: rgb(240, 240, 240);
  .footer-box {
    width: 1200px;
    display: flex;
     align-items: flex-end;
    justify-content: space-between;
    margin: 0 auto;
    padding-top: 35px;
    padding-bottom: 33px;
    box-sizing: border-box;
    text-align: left;
    .footer-left {
      .logo-box {
        width: 129px;
        height: 50px;
        img {
          width: 129px;
          height: 50px;
        }
      }
      .logo-slogan {
        position: relative;
        font-size: 14px;
        line-height: 14px;
        font-family: Source Han Sans CN;
        font-weight: normal;
        color: #08070c;
        margin-top: 16px;
      }
      .mp-name {
        position: relative;
        font-size: 12px;
        line-height: 12px;
        font-family: Source Han Sans CN;
        font-weight: normal;
        color: #666666;
        margin-top: 28px;
      }
      .compnay-name {
        position: relative;
        font-size: 16px;
        line-height: 16px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #08070c;
        margin-top: 6px;
      }
      .center-link {
        font-size: 14px;
        color: #ec4040;
        margin-top: 24px;
        cursor: pointer;
      }
    }
    .footer-center {
      position: relative;
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: normal;
      color: #666666;
      box-sizing: border-box;
      .center-link {
        text-align: center;
        font-size: 12px;
        cursor: pointer;
        &.current {
          color: #b50229;
        }
      }
    }
    .footer-right {
      .item {
        margin-top: 18px;
        &:first-child {
          margin-top: 0;
        }
        .label {
          position: relative;
          font-size: 12px;
          line-height: 12px;
          //  font-family: "SourceHanSansCN";
          font-family: Source Han Sans CN;
          font-weight: normal;
          color: #666666;
        }
        .text {
          position: relative;
          font-size: 16px;
          line-height: 16px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #08070C;
          margin-top: 8px;
        }
      }
    }
  }
}
</style>
